// @flow
import { useMemo } from 'react';
import moment from 'moment-timezone';
import values from 'ramda/es/values';
import filter from 'ramda/es/filter';
import map from 'ramda/es/map';
import pipe from 'ramda/es/pipe';
import complement from 'ramda/es/complement';
import equals from 'ramda/es/equals';
import always from 'ramda/es/always';

import type { OrgsSchools, OrgItem } from './useOrgs';
import hasSingleTarget from './hasSingleTarget';

/**
 *  Извлекает массив актуальных заведений
 *  (не удаленных и подходящих по дате и если указан orgId заведения, то без этого заведения)
 */

type ActualOrg = {
  id: number,
  key: number,
  label: string,
  hasSingleTarget: boolean,
}

type Options = {
  orgId?: number,
  date?: string,
}

export default function useActualOrgs(orgs: OrgsSchools, options: Options) {
  const { orgId, date } = options;

  const res: Array<ActualOrg> = useMemo(() => {
    const byOrgId = orgId ? complement(equals(orgId)) : always(true);

    const mDate = moment(date);
    const isValidDate = Boolean(date && mDate.isValid());
    const byDate = (isValidDate
      ? (from: string | null) => (from ? mDate.isAfter(from, 'day') : true)
      : always(true));

    return pipe(
      values,
      filter(({ deleted, from, id }: OrgItem) => (
        !deleted
          && byOrgId(id)
          && byDate(from)
      )),
      map((orgItem: OrgItem) => {
        const { id, title } = orgItem;

        return ({
          id,
          key: id,
          label: title,
          hasSingleTarget: hasSingleTarget(orgItem),
        });
      }),
    )(orgs);
  }, [orgs, orgId, date]);

  return res;
}
